export const validatorTypes = {
  ValidatorService: Symbol.for("ValidatorService"),
}
